function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0H1440V1272H0z",
  transform: "translate(-268 -158)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#93A0BA",
  d: "M273.293 166.293c.39-.39 1.024-.39 1.414 0l4.95 4.95 4.95-4.95c.39-.39 1.023-.39 1.414 0 .39.39.39 1.024 0 1.414l-5.657 5.657c-.39.39-1.024.39-1.414 0l-5.657-5.657c-.39-.39-.39-1.024 0-1.414z",
  transform: "translate(-268 -158)"
}));

var SvgIc24ChevronBottom = function SvgIc24ChevronBottom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIc24ChevronBottom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-24-chevron-bottom.de78b2e9.svg";
export { ForwardRef as ReactComponent };